const styles = theme => ({
  cell: {
    padding: 5,
  },
  menuButton: {
    marginLeft: -12,
    marginRight: 20,
  },
  root: {
    marginTop: theme.spacing.unit * 3,
    overflowX: 'auto',
    width: '100%',
  },
  table: {
    margin: 0,
  },
});

export default styles;
